<template>
  <div class="page-effect padding-short">
    <!-- <section class="ss-reg-top"> -->
    <div class="container-fluid border-bottom page-option-sticky sticky-without-menu p-0">
      <div class="d-md-flex justify-content-end ss-reg-top">
        <a
          href="#"
          class=""
          data-toggle="modal"
          data-target="#welcomemailModalCenter"
          @click="$refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')"
          >
          <img src="../assets/Images/icons/mail-template.svg" class="mr-1" style="width: 16px; height: 16px;">
          Send Mail
          </a
        >
        <a
          id="reg_type_dialog"
          href="#"
          class="pl-3"
          data-toggle="modal"
          data-target="#RegistrationtypeModal"
          @click="$refs.addEditRegistrationTypePopup.getRegistrationTypes()"
          >
          <img src="../assets/Images/icons/reg-type.svg" class="mr-1" style="width: 16px; height: 16px;">
          Registration Types
          </a
        >
        <a
          href="#"
          class="pl-3"
          data-toggle="modal"
          data-target="#CheckoutformypeModal"
          @click="$refs.addEditCheckoutFormPopup.getAllCheckoutForms()"
          >
          <img src="../assets/Images/icons/checkout-form.svg" class="mr-1" style="width: 16px; height: 16px;">
          Checkout Form
          </a
        >
        
        <!-- <a href="#" class="pl-2" @click="getRegFormConfig">
          <v-icon>mdi-cog-outline</v-icon>
        </a> -->
      </div>
    </div>
    <!-- </section> -->
    <div>
      <RegV3 ref="regV3" :isAdminComponent="true" :speeakerAddEditDialog="false"> </RegV3>
    </div>

    <ReminderAnnounceMailPopup ref="reminderAnnounceMailPopup" />
    <AddEditRegistrationTypePopup ref="addEditRegistrationTypePopup" />
    <AddEditCheckoutFormPopup ref="addEditCheckoutFormPopup" />

    <!--- ADVANCE SETTINGS -->
    <v-dialog v-model="popupPayingtoLogo" width="700">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Checkout Form Payment Settings
        </v-card-title>
        <v-card-text style="max-height: 400px; overflow-y: auto">
          <v-row class="mt-2">
            <v-col md="12" sm="12" cols="12">
              <div class="drag-drop-sponsor-logo">
                <input
                  type="file"
                  value=""
                  class="select-file"
                  accept="image/*"
                  @change="
                    update_logo($event, '960x192', {
                      key: 'PayingToLogo',
                      field: 'regFormConfig',
                    })
                  "
                />
                <img :src="regFormConfig.PayingToLogo" />
                <p>960x192px PNG, JPG Max 3MB</p>
              </div>
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-text-field
                label="Submit Button Display Label"
                v-model="regFormConfig.SubmitButtonDisplaylabel"
              />
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-text-field label="Paying To" v-model="regFormConfig.PayingTo" />
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-switch
                v-model="regFormConfig.LandingPageShowHostedByPanel"
                label="Show Landing Page Hosted By Panel"
              ></v-switch>
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-switch
                v-model="regFormConfig.LandingPageShowEventListLink"
                label="Show Landing Page Event List Link"
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            outlined
            class="px-5 mr-3 py-4"
            @click="popupPayingtoLogo = false"
            >CANCEL</v-btn
          >          
          <v-btn color="primary" v-if="loadingButton"><v-progress-circular indeterminate></v-progress-circular></v-btn>
          <v-btn color="primary" v-else @click="setRegFormConfig"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "../components/firebaseInit";
import APIs from "@/components/APIInit";
import router from "../router";
import store from "../store";
import jQuery from "jquery";
let $ = jQuery;
var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";

import RegV3 from "@/views/RegV3.vue";
import ReminderAnnounceMailPopup from "@/views/ReminderAnnounceMailPopup.vue";
import AddEditRegistrationTypePopup from "@/views/AddEditRegistrationTypePopup.vue";
import AddEditCheckoutFormPopup from "@/views/AddEditCheckoutFormPopup.vue";

Vue.use(VueMoment, {
  moment,
});

export default {
  components: {
    RegV3,
    ReminderAnnounceMailPopup,
    AddEditRegistrationTypePopup,
    AddEditCheckoutFormPopup,
  },
  data() {
    return {
      event_timezone: store.getters.getZone,
      event_collectionName: null,
      userID: null,
      speeakerListKey: 0,
      speeakerAddEditKey: 0,
      speeakerAddEditDialog: false,
      Speaker: {},
      EventsData: [],
      blankRules: [(v) => !!v || "This field is required"],
      //clientID: "",
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      eventcollectionname: null,
      clientID: null,
      eventid: null,
      popupPayingtoLogo: false,
      clientLogoUrl: null,
      ClientName: null,
      regFormConfig: null,
      loadingButton: false
    };
  },
  computed: {},
  watch: {},
  async created() {
    self = this;
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });

    self.eventcollectionname = self.getEventCollectionName();
    self.clientID = self.getClientId();
    self.eventid = self.getEventId();
    self.event_collectionName = self.getEventCollectionName();
    self.userID = self.getSessionUserId();
  },
  mounted() {
    //self.clientID = self.$route.query.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media")
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        db.collection("OA_UAT")
          .doc("ClientList")
          .collection("Clients")
          .doc(self.clientID)
          .get()
          .then(function (doc) {
            var data = doc.data();
            console.log(data);
            //debugger;
            self.clientLogoUrl = data.LoginAssets.logo;
            self.ClientName = data.ClientName;
            self.regFormConfig = {
              PayingToLogo: data.LoginAssets.logo ? data.LoginAssets.logo : "",
              SubmitButtonDisplaylabel: "SUBMIT",
              PayingTo: data.ClientName ? data.ClientName : null,
              LandingPageShowHostedByPanel: false,
              LandingPageShowEventListLink: false,
            };
            // self.clientProfile = data.Company;

            // self.desktopBanner = data.EventListAssets.banner2048x88;
            // self.mobileBanner = data.EventListAssets.banner750x103;
            //  self.BannerURL = data.EventListAssets.banner640x88;
            self.initScreen();
          });
      });
    //$("#imgBanner").attr("src", self.BannerURL);

    if (self.$route.hash == "#type") {
      document.getElementById("reg_type_dialog").click();
    }
  },
  methods: {
    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    setAdminSettings(adminSettings) {
      //console.log('hi there', adminSettings)
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        },
        data: adminSettings,
      };
      axios
        .post(APIs.SelfServiceEventConfig, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            self.showSnackbar("Data updated", "success", "top");
          } else {
            self.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    saveEventinfo(EventsData, HostInfo) {
      bus.$emit("toggleLoader", true);
      let dataObj = {
        Description: EventsData.Description,
        EventLogo: EventsData.EventLogo,
      };
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        },
        data: dataObj,
      };
      axios
        .post(APIs.SaveEventAPI, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 200) {
            self.showSnackbar("Data updated", "success", "top");
            self.setBrandingJson([
              { key: "EventInfo", obj: dataObj },
              { key: "HostInfo", obj: HostInfo },
            ]);
          } else {
            self.showSnackbar("Data not updated!", "error", "top");
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    update_logo(input, fileWH, uploadedField) {
      // You can update avatar Here
      //console.log(self.$refs.regV3.EventsData[0].EventLogo)
      if (input) {
        let file = input.target.files[0];
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        let uploadTargetPath = `${self.getEventCollectionName()}/Branding/`;
        if (uploadedField.field == "regFormConfig")
          uploadTargetPath = `${self.getEventCollectionName()}/Registration/`;
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width >= dimension[0] && this.height >= dimension[1]) {
            const reader = new FileReader();
            reader.onload = (e) => {
              let fileBlob = e.target.result;
              //self.$refs.regV3.EventsData[0].EventLogo = fileBlob;
              self.uploadServerImage(fileBlob, uploadTargetPath, file, uploadedField);
            };
            reader.readAsDataURL(file);
          } else {
            alert("Please upload a banner " + fileWH + " px");
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadServerImage(fileBlob, target, file, uploadedField) {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        },
        files: [{ blob: fileBlob, target: target, name: file.name, type: file.type }],
      };
      axios
        .post(APIs.UploadFiles, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (
            res.data.status == 0 &&
            res.data.data.length &&
            res.data.data[0].status == "fulfilled"
          ) {
            self.showSnackbar("Uploaded Successfully.", "success", "top");
            if (uploadedField) {
              if (uploadedField.field == "EventsData") {
                self.$refs.regV3.EventsData[0][uploadedField.key] =
                  res.data.data[0].value.url;
                self.saveEventinfo(
                  self.$refs.regV3.EventsData[0],
                  self.$refs.regV3.HostInfo
                );
              } else if (uploadedField.field == "regFormConfig") {
                self.regFormConfig[uploadedField.key] = res.data.data[0].value.url;
              } else {
                self.$refs.regV3[uploadedField.field][uploadedField.key] =
                  res.data.data[0].value.url;
              }
            }
          } else self.showSnackbar("Unable to upload!", "error", "top");
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    setBrandingJson(mainKey, subKeyValObj = null) {
      let dataArr = [];
      if (Array.isArray(mainKey)) {
        for (let item of mainKey) {
          dataArr.push({
            mainKey: item.key,
            subKeys: Object.keys(item.obj),
            subKeyValObj: item.obj,
          });
        }
      } else {
        let subKeys = Object.keys(subKeyValObj);
        dataArr.push({
          mainKey: mainKey,
          subKeys: subKeys,
          subKeyValObj: subKeyValObj,
        });
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        },
        data: dataArr,
      };
      axios.post(APIs.SaveEventBrandingJson, requestData, { headers: headers });
    },
    getRegFormConfig() {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
        instanceId: "OA_UAT",
        clientId: self.clientID,
        eventId: self.eventid,
      };

      axios
        .get(APIs.regFormAPI, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (res.data.status == 0) {
            if (res.data.data) self.regFormConfig = res.data.data;
            self.popupPayingtoLogo = true;
          }
        })
        .catch((err) => {
          bus.$emit("toggleLoader", false);
          self.showSnackbar(err, "error", "top");
        });
    },
    setRegFormConfig() {
      bus.$emit("toggleLoader", true);
      self.loadingButton = true;
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };

      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientID,
          eventId: self.eventid,
        },
        data: self.regFormConfig,
      };

      axios
        .post(APIs.regFormAPI, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          self.loadingButton = false;
          if (res.data.status == 0) {
            self.showSnackbar("Data Updated Successfully.", "success", "top");
            self.popupPayingtoLogo = false;
          }
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          self.loadingButton = false;
          self.showSnackbar("Something went wrong!", "error", "top");
        });
    },
  },
};
</script>
